import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  surgeryRooms: {
    data: [],
    isLoading: false,
    message: null,
  },
  doctors: {
    data: [],
    isLoading: false,
    message: null,
  },
};

export const selectOptionsSlice = createSlice({
  name: "selectOptions",
  initialState,
  reducers: {
    setSelectOptions(state, { payload }) {
      const { key, data } = payload;
      if (state[key]) {
        state[key].data = data[key];
        state[key].isLoading = false;
        state[key].message = {
          type: "successSelect",
          text: data.message || `${key} obtenidos con exito`,
        };
      }
    },
    setSelectLoading(state, { payload }) {
      const { key } = payload;
      if (state[key]) {
        state[key].isLoading = true;
        state[key].message = null;
      }
    },
    setSelectError(state, { payload }) {
      const { key, message } = payload;
      if (state[key]) {
        state[key].isLoading = false;
        state[key].message = {
          type: "errorSelect",
          text: message,
        };
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectOptions, setSelectLoading, setSelectError } =
  selectOptionsSlice.actions;
